"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSkuValue = exports.getSkuKeyValue = exports.formatResponses = exports.build2gUpgradeBody = exports.buildComponentsBody = exports.buildCaptureBody = exports.buildRecommendationsBody = exports.buildCreateBody = exports.lead2gUpgrade = exports.submitIdeasFormSubmitRequest = exports.leadGenSubscribe = exports.leadGenUnsub = exports.leadGenCapture = exports.leadGenRecommendations = exports.leadGenUpdate = exports.leadGenCreate = void 0;
/* eslint-disable max-lines */
/* eslint @typescript-eslint/no-explicit-any: 1 */
const safeProp_1 = require("../utils/safeProp");
const browser_monads_1 = require("browser-monads");
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const defaultTo_1 = __importDefault(require("ramda/src/defaultTo"));
const path_1 = __importDefault(require("ramda/src/path"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const config_1 = require("../config");
const capture_1 = require("../leads/capture");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const leadGen_1 = require("../secrets/leadGen");
const errorLogging_1 = require("../thirdparty/errorLogging");
const fluture_utils_1 = require("../utils/fluture-utils");
const windowScreenSize_1 = require("../utils/windowScreenSize");
const headerJson = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};
const methodPost = { method: 'POST' };
const defaultParams = {
    ...methodPost,
    headers: headerJson,
};
const handleLeadGenResponse = (future) => future.pipe(fluture_utils_1.verifyResponse)
    .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
    .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
    .pipe((0, fluture_1.chainRej)(perimeterX_1.default));
const leadGenCreate = (request) => (handleFailure) => (handleSuccess) => // TODO add return type and remove any
 (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${leadGen_1.quoteWizardUrl}/capture`, buildCreateFetchOptions(request)))
    .pipe(handleLeadGenResponse)
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.leadGenCreate = leadGenCreate;
const leadGenUpdate = (request) => (handleFailure) => (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${leadGen_1.quoteWizardUrl}/capture/${request.leadId}`, buildUpdateFetchOptions(request)))
    .pipe(fluture_utils_1.verifyResponse)
    .pipe((0, fluture_1.chainRej)(perimeterX_1.default))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(() => null));
exports.leadGenUpdate = leadGenUpdate;
const leadGenRecommendations = (request) => (handleFailure) => (handleSuccess) => // TODO add return type and remove any
 (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${leadGen_1.quoteWizardUrl}/recommendation`, buildRecommendationsFetchOptions(request)))
    .pipe(handleLeadGenResponse)
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.leadGenRecommendations = leadGenRecommendations;
const leadGenCapture = (request) => (handleFailure) => (handleSuccess) => (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(leadGen_1.leadCaptureUrl, buildCaptureFetchOptions(request)))
    .pipe(r => handleLeadGenResponse(r))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.leadGenCapture = leadGenCapture;
const leadGenUnsub = (request) => (handleFailure) => (handleSuccess) => // TODO add return type and remove any
 (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(leadGen_1.leadUnsubUrl, buildSubscriptionFetchOptions(request)))
    .pipe(fluture_utils_1.verifyResponse)
    .pipe((0, fluture_1.chainRej)(perimeterX_1.default))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.leadGenUnsub = leadGenUnsub;
const leadGenSubscribe = (request) => (handleFailure) => (handleSuccess) => // TODO add return type and remove any
 (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(leadGen_1.leadSubscribeUrl, buildSubscriptionFetchOptions(request)))
    .pipe(fluture_utils_1.verifyResponse)
    .pipe((0, fluture_1.chainRej)(perimeterX_1.default))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.leadGenSubscribe = leadGenSubscribe;
const submitIdeasFormSubmitRequest = (request) => (handleFailure) => (handleSuccess) => // TODO add return type and remove any
 (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(leadGen_1.submitIdeasUrl, buildSubmitIdeasFormFetchOptions(request)))
    .pipe(handleLeadGenResponse)
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.submitIdeasFormSubmitRequest = submitIdeasFormSubmitRequest;
const lead2gUpgrade = (request) => (handleFailure) => (handleSuccess) => // TODO add return type and remove any
 (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(leadGen_1.lead2gUpgradeUrl, build2gUpgradeFetchOptions(request)))
    .pipe(handleLeadGenResponse)
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.lead2gUpgrade = lead2gUpgrade;
const buildSubmitIdeasFormFetchOptions = (data) => {
    return ({
        ...defaultParams,
        body: data,
        // Browser must set the content-type for multipart/form-data
        headers: {},
        method: 'POST'
    });
};
const buildCreateFetchOptions = (params) => ({
    ...defaultParams,
    body: JSON.stringify((0, exports.buildCreateBody)(params))
});
const buildUpdateFetchOptions = (params) => ({
    ...defaultParams,
    body: JSON.stringify({
        'locale': (0, config_1.getLocale)(),
        'name': (0, path_1.default)(['responses', 'name'], params),
        'phone': (0, path_1.default)(['responses', 'phone'], params)
    })
});
const buildRecommendationsFetchOptions = (params) => ({
    ...defaultParams,
    body: JSON.stringify((0, exports.buildRecommendationsBody)(params))
});
const buildCaptureFetchOptions = (params) => ({
    ...defaultParams,
    body: JSON.stringify((0, exports.buildCaptureBody)(params))
});
const buildSubscriptionFetchOptions = (params) => ({
    ...defaultParams,
    body: JSON.stringify({
        locale: (0, config_1.getLocale)(),
        mail: (0, prop_1.default)('email', params)
    })
});
const build2gUpgradeFetchOptions = (params) => ({
    ...defaultParams,
    body: JSON.stringify((0, exports.build2gUpgradeBody)(params))
});
/**
 * Transform a LeadGenCreateParams into what the API expects
 *
 * See:
 * https://simplisafe.atlassian.net/wiki/spaces/FCP/pages/1716027837/Quote+Wizard+Lead+Documentation
 * https://api.qa.commerce.simplisafe.com/release/leads/v1/docs#tag/Quote-Wizard/paths/~1quote-wizard~1capture/post
 *
 * @param LeadGenCreateParams params
 */
const buildCreateBody = (params) => {
    const utmParams = (0, capture_1.getUTMParams)();
    return {
        'completed': 1,
        'email': (0, path_1.default)(['responses', 'email'], params),
        'landing_page': getLandingPageParam(params),
        'lead_promo_offer': (0, prop_1.default)('leadPromoOffer', params) || null,
        'lead_source_details': (0, prop_1.default)('format', params),
        'lead_source_type': 'quote_wizard',
        'lead_source_version': JSON.stringify(params.leadSourceVersion || {}),
        'lead_type': 'null',
        'locale': (0, config_1.getLocale)(),
        'questions': (0, exports.formatResponses)((0, prop_1.default)('responses', params)),
        'show_phone_field': (0, config_1.getLocale)() === 'en-GB' && params.showPhoneField ? 1 : 0,
        'type': getTypeParam(params),
        'visitor_id': (0, prop_1.default)('visitorId', params),
        'wizard_id': getWizardIdParam(params),
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        'url_path': browser_monads_1.window.location.pathname,
        'utm_campaign': (0, prop_1.default)('utm_campaign', utmParams) || null,
        'utm_medium': (0, prop_1.default)('utm_medium', utmParams) || null,
        'utm_source': (0, prop_1.default)('utm_source', utmParams) || null,
    };
};
exports.buildCreateBody = buildCreateBody;
/**
 * Transform a LeadGenCreateParams into what the recommendations API expects
 *
 * See https://api.qa.commerce.simplisafe.com/release/leads/v1/docs#tag/Recommendations
 *
 * TODO: refactor this code to pull a list of SKUs at build-time rather than
 * relying on hard-coded data which can result in instability since SKU values
 * can change and be updated in real-time
 *
 * @param LeadGenCreateParams params
 */
const buildRecommendationsBody = (params) => {
    const formatProp = params.format;
    const qwType = formatProp === 'embedded' ? 'Embedded' : 'Nav';
    const utmParams = (0, capture_1.getUTMParams)();
    const components = (0, exports.buildComponentsBody)(params);
    return {
        'components': { ...components },
        'email': (0, path_1.default)(['responses', 'email'], params),
        'lead_promo_offer': (0, safeProp_1.safeProp)('leadPromoOffer', params).orNull(),
        'lead_source_details': formatProp,
        'lead_source_type': 'quote_wizard_recs',
        'lead_source_version': JSON.stringify(params.leadSourceVersion || {}),
        'lead_type': 'null',
        'locale': (0, config_1.getLocale)(),
        'source': `${qwType} Quote Wizard - ${(0, windowScreenSize_1.getDeviceType)()}`,
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        'url_path': browser_monads_1.window.location.pathname,
        'utm_campaign': utmParams.utm_campaign || null,
        'utm_medium': utmParams.utm_medium || null,
        'utm_source': utmParams.utm_source || null
    };
};
exports.buildRecommendationsBody = buildRecommendationsBody;
/**
 * Transform a LeadGenCaptureParams into what the API expects
 *
 * @param LeadGenCaptureParams params
 */
const buildCaptureBody = (params) => {
    const utmParams = (0, capture_1.getUTMParams)();
    return {
        'email': (0, prop_1.default)('email', params),
        'lead_promo_offer': (0, prop_1.default)('promoCode', params),
        'lead_source_details': (0, defaultTo_1.default)('embedded')((0, prop_1.default)('leadSource', params)),
        'lead_source_type': (0, defaultTo_1.default)('promo')((0, prop_1.default)('sourceType', params)),
        'lead_source_version': JSON.stringify((0, defaultTo_1.default)({})((0, prop_1.default)('leadVersion', params))),
        'lead_type': (0, defaultTo_1.default)('partner')((0, prop_1.default)('leadType', params)),
        'locale': (0, config_1.getLocale)(),
        'source': (0, defaultTo_1.default)('null')((0, prop_1.default)('source', params)),
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        'url_path': browser_monads_1.window.location.pathname,
        'utm_campaign': (0, prop_1.default)('utm_campaign', utmParams) || null,
        'utm_medium': (0, prop_1.default)('utm_medium', utmParams) || null,
        'utm_source': (0, prop_1.default)('utm_source', utmParams) || null,
    };
};
exports.buildCaptureBody = buildCaptureBody;
// Abstracted this out to reduce code complexity
const buildComponentsBody = (params) => {
    const getResponsesSkuKeyValue = (0, exports.getSkuKeyValue)((0, prop_1.default)('responses', params));
    const responsesHaveSkuValue = (0, exports.hasSkuValue)((0, prop_1.default)('responses', params));
    return {
        'auxiliarySiren': responsesHaveSkuValue('SSWS3') ? 1 : 0,
        'bellBox': responsesHaveSkuValue('CA003-01DUK') ? 1 : 0,
        'carbonMonoxideDetector': responsesHaveSkuValue('SSCO3') ? 1 : 0,
        'entrySensor': getResponsesSkuKeyValue('SSES3'),
        'freezeSensor': responsesHaveSkuValue('SSFS3') ? 1 : 0,
        'glassbreakSensor': responsesHaveSkuValue('SSGB3') ? 1 : 0,
        'indoorCam': responsesHaveSkuValue('CM006-01DWW') ? 1 : 0,
        'keyFob': getResponsesSkuKeyValue('SSES3') >= 7 ? 1 : 0,
        'keypad': responsesHaveSkuValue('SSKP3') ? 1 : 0,
        'motionSensor': getResponsesSkuKeyValue('CA001-01DWW'),
        'outdoorCamera': responsesHaveSkuValue('CMOB1') ? 1 : 0,
        'panicButton': responsesHaveSkuValue('SSPB3') ? 1 : 0,
        'simplicam': responsesHaveSkuValue('SSCM2') ? 1 : 0,
        'smokeDetector': responsesHaveSkuValue('SSSD3') ? 1 : 0,
        'videoDoorbellPro': responsesHaveSkuValue('SSDB3') ? 1 : 0,
        'waterSensor': responsesHaveSkuValue('SSWT3') ? 1 : 0
    };
};
exports.buildComponentsBody = buildComponentsBody;
/**
 * Transform a Lead2gUpgradeParams into what the API expects
 *
 * @param Lead2gUpgradeParams params
 */
const build2gUpgradeBody = (params) => {
    return {
        'city': (0, prop_1.default)('city', params),
        'email': (0, prop_1.default)('email', params),
        'firstName': (0, prop_1.default)('firstName', params),
        'lastName': (0, prop_1.default)('lastName', params),
        'locale': (0, config_1.getLocale)(),
        'phonenumber': (0, prop_1.default)('phoneNumber', params),
        'sidnumber': (0, prop_1.default)('sidNumber', params),
        'state': (0, prop_1.default)('state', params),
        'streetAddress1': (0, prop_1.default)('streetAddress1', params),
        'streetAddress2': (0, prop_1.default)('streetAddress2', params),
        'zipCode': (0, prop_1.default)('zipCode', params),
    };
};
exports.build2gUpgradeBody = build2gUpgradeBody;
/**
 * 'home' or 'popup' with country optionally prepended
 *
 * @param QuoteWizardFormat format
 * @param string locale
 */
const getLandingPageParam = ({ format }) => {
    const locale = (0, config_1.getLocale)();
    return format === 'popup'
        ? locale === 'en-GB'
            ? 'uk-popup'
            : 'popup'
        : locale === 'en-GB'
            ? 'uk-home'
            : 'home';
};
/**
 * 'popup' for GB/popup else null
 *
 * @param QuoteWizardFormat format
 * @param string locale
*/
const getTypeParam = ({ format }) => {
    const locale = (0, config_1.getLocale)();
    return format === 'popup' && locale === 'en-GB' ? format : null;
};
/**
 * 2/4/6/8 for US embedded/popup and UK embedded/popup
 * Origin is ss_quote_wizard.idnmb; definitely less ideal
 *
 * @param QuoteWizardFormat format
 * @param string locale
 */
const getWizardIdParam = ({ format }) => {
    const locale = (0, config_1.getLocale)();
    const localeModifier = locale === 'en-GB' ? 4 : 0;
    const formatModifier = format === 'popup' ? 4 : 2;
    return localeModifier + formatModifier;
};
/**
 * Fun sorting algorithm for Drupal processing. Drupal needs
 * question 12, then question 4, then question 6, then
 * anything else.
 *
 * @param String a
 * @param String b
 */
const sortForDrupalProcessingUK = (a, b) => a === '12' ? -1
    : a === '4' ? -1
        : b === '4' ? 1
            : a === '6' ? -1
                : b === '6' ? 1
                    : 0;
/**
 * US sorting is in numerical ascending order, so convert string keys
 * to integers and find the difference does the trick
 *
 * @param String a
 * @param String b
 */
const sortForDrupalProcessingUS = (a, b) => {
    const aInt = parseInt(a);
    const bInt = parseInt(b);
    return aInt - bInt;
};
/**
 * Strip out 'email' key and treat the rest as question/answer pairs.
 * Very specifically sort questions '12', '4', and '6' to the top. If Drupal
 * doesn't get them in this specific order it won't tag the lead correctly
 * and no email will be sent.
 *
 * @param Record<string, unknown>[] responses
 */
const formatResponses = (responses) => Object.keys(responses)
    .filter(key => key !== 'email')
    .sort((0, config_1.getLocale)() === 'en-GB' ? sortForDrupalProcessingUK : sortForDrupalProcessingUS)
    .map(key => {
    return {
        'question_choice_id': responses[key],
        'question_id': key
    };
});
exports.formatResponses = formatResponses;
/**
 * Return numeric value of SKU key in object
 *
 * @param Record<string, unknown> responses
 */
const getSkuKeyValue = (responses) => (sku) => monet_1.Maybe.fromUndefined((0, prop_1.default)(sku, responses)).getOrElse(0);
exports.getSkuKeyValue = getSkuKeyValue;
/**
 * Return whether SKU exists in any CSV value in object
 *
 * @param Record<string, unknown> responses
 */
const hasSkuValue = (responses) => (sku) => Object.values(responses)
    .some((val) => {
    return (val).toString()
        .split(',')
        .some(x => x.toLowerCase() === sku.toLowerCase());
});
exports.hasSkuValue = hasSkuValue;
//# sourceMappingURL=leadGenClient.js.map